import axios from "axios";

const serviceUploadInstance = (isMocked = false) =>
  axios.create({
    baseURL: isMocked
      ? "http://localhost:3001"
      : `${process.env.REACT_APP_API_URL || 'https://apim-logistica-dev-eastus-001.azure-api.net'}/ead`,
    headers: {
      "Content-Type": "multipart/form-data",
      Accept: "*/*",
      "Ocp-Apim-Subscription-Key": `${process.env.REACT_APP_API_KEY || '344a4ae0c7ca429e932a2812cfd36648'}`,
    },
  });

export { serviceUploadInstance };
